import { WRONG_ADDRESS as type } from '../actions/wrongAddressTypes';

const initialState = {
    getExistAddressTypesLoading: false,
    getExistAddressTypes: {},
    getExistAddressTypesError: false,
    getDeliveryTypesLoading: false,
    getDeliveryTypes: {},
    getDeliveryTypesError: false,
    getProvincesCoveredLoading: false,
    getProvincesCovered: [],
    getProvincesCoveredError: false,
    getservicewrongaddressLoading: false,
    getservicewrongaddress: {},
    getservicewrongaddressError: false
}

export default function wrongAddressReducer(state = initialState, action){
    switch(action.type){
        case type.GET_SERVICE_WRONG_ADDRESS:
            return {
                ...state,
                getservicewrongaddressLoading: true
            }
        case type.GET_SERVICE_WRONG_ADDRESS_SUCCESS:
            return {
                ...state,
                getservicewrongaddress: action.payload, 
                getservicewrongaddressLoading: false      
            }
        case type.GET_SERVICE_WRONG_ADDRESS_FAIL:
            return {
                ...state,
                getservicewrongaddressLoading: false,
                getservicewrongaddressError: action.payload,
                getservicewrongaddress: initialState.getservicewrongaddress
            }
        case type.GET_EXIST_ADDRESS_TYPES:
            return {
                ...state,
                getExistAddressTypesLoading: true
            }
        case type.GET_EXIST_ADDRESS_TYPES_SUCCESS:
            return {
                ...state,
                getExistAddressTypes: action.payload, 
                getExistAddressTypesLoading: false      
            }
        case type.GET_EXIST_ADDRESS_TYPES_FAIL:
            return {
                ...state,
                getExistAddressTypesLoading: false,
                getExistAddressTypesError: action.payload
            }
        case type.GET_DELIVERY_TYPES:
            return {
                ...state,
                getDeliveryTypesLoading: true
            }
        case type.GET_DELIVERY_TYPES_SUCCESS:
            return {
                ...state,
                getDeliveryTypes: action.payload, 
                getDeliveryTypesLoading: false      
            }
        case type.GET_DELIVERY_TYPES_FAIL:
            return {
                ...state,
                getDeliveryTypesLoading: false,
                getDeliveryTypesError: action.payload
            }
        case type.GET_PROVINCES_COVERED:
            return {
                ...state,
                getProvincesCoveredLoading: true
            }
        case type.GET_PROVINCES_COVERED_SUCCESS:
            return {
                ...state,
                getProvincesCovered: action.payload, 
                getProvincesCoveredLoading: false      
            }
        case type.GET_PROVINCES_COVERED_FAIL:
            return {
                ...state,
                getProvincesCoveredLoading: false,
                getProvincesCoveredError: action.payload
            }
        default:
            return state;
    }
}